import { render } from "./TkDocumentsPanel.vue?vue&type=template&id=5ec7a4c6&scoped=true"
import script from "./TkDocumentsPanel.vue?vue&type=script&lang=js"
export * from "./TkDocumentsPanel.vue?vue&type=script&lang=js"

import "./TkDocumentsPanel.vue?vue&type=style&index=0&id=5ec7a4c6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec7a4c6"]])

export default __exports__
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFile,QIcon,QInput,QBtn,QSelect,QTable,QTd,QTooltip,QField});
